// extracted by mini-css-extract-plugin
module.exports = {"draggable":"src-components-Page-components-stylesEditorHotspot__draggable--Rdfq_","topLeft":"src-components-Page-components-stylesEditorHotspot__topLeft--1zJe9"};